module.exports = __webpack_public_path__ + "img/洛丽塔衣橱课.2bb67828.png";